import Logo from '@liveauctioneers/caterwaul-components/lib/Assets/Logo';
import { SubtleMonochromeLink } from '@liveauctioneers/hammer-ui-core/link';

import LiveAuctionSettingsMenu from '@/pages/BiddingConsole/components/LiveAuctionSettingsMenu/LiveAuctionSettingsMenu';
import { useAppSelector } from '@/redux/hooks';
import {
    getCatalogSellerId,
    getCatalogSellerName,
    getCatalogTitle,
} from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getCatalogUrl, getHomeUrl, getSellerUrl } from '@/utils/urls';

type Props = {
    catalogId: number;
    onCurrencyChanged: (value: string) => void;
    selectedCurrency: string;
};

export const AuctionNameAndSettingsBlock = ({ catalogId, onCurrencyChanged, selectedCurrency }: Props) => {
    const catalogTitle = useAppSelector((state) => getCatalogTitle(state, catalogId));
    const catalogSellerName = useAppSelector((state) => getCatalogSellerName(state, catalogId));
    const sellerId = useAppSelector((state) => getCatalogSellerId(state, catalogId));
    const catalogUrl = useAppSelector(() => getCatalogUrl(catalogId, catalogTitle));
    const sellerUrl = useAppSelector(() => getSellerUrl(sellerId, catalogSellerName));

    return (
        <div className="rounded-sm border border-border-secondary bg-background-primary p-md">
            <div className="mb-md flex items-center justify-between">
                <SubtleMonochromeLink
                    href={getHomeUrl()}
                    target="_blank"
                >
                    <Logo
                        height="24px"
                        width="179px"
                    />
                </SubtleMonochromeLink>
                <LiveAuctionSettingsMenu
                    catalogId={catalogId}
                    onCurrencyChanged={onCurrencyChanged}
                    selectedCurrency={selectedCurrency}
                />
            </div>
            <div className="flex flex-col gap-2xs">
                <SubtleMonochromeLink
                    href={catalogUrl}
                    target="_blank"
                >
                    {catalogTitle}
                </SubtleMonochromeLink>
                <SubtleMonochromeLink
                    href={sellerUrl}
                    target="_blank"
                >
                    {catalogSellerName}
                </SubtleMonochromeLink>
            </div>
        </div>
    );
};
